// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-background {
    width: 100%;
    flex-shrink: 0;
    border-radius: 1.5rem;
    background-color: var(--background-color);
    margin: 0rem 0.75rem;
    justify-content: center;
    align-items: center;
    padding: 1rem;
}

.custom-table {
    height: 100vh;
    width: 100%;
    border-collapse: collapse;
}

.custom-table th,
.custom-table td {
    height: 4.3125rem;
    padding: 1rem;
}

.custom-table th:first-child,
.custom-table td:first-child {
    border-radius: 0.75rem 0 0 0.75rem;
}

.custom-table th:last-child,
.custom-table td:last-child {
    border-radius: 0 0.75rem 0.75rem 0;
}

.custom-table td {
    position: relative;
}

.custom-table td:last-child::after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    background-color: var(--background-color);
    bottom: 0;
    left: 0;
    transition: width 0.3s ease;
}

.custom-table td:last-child:hover::after {
    width: 100%;
}

.custom-table .align-left {
    text-align: left;
}

.custom-table .align-right {
    text-align: right;
}

.custom-table tr:nth-child(even) {
    background: rgba(217, 217, 217, 0.15);
}

.custom-table tr.with-link:hover {
    background-color: rgba(217, 217, 217, 0.3);
    cursor: pointer;
}

.custom-table tr.with-link:hover td:last-child::after {
    width: 100%;
}

.custom-table .table-header:hover {
    background-color: transparent;
    cursor: default;
}

.custom-table td.with-link:hover::after {
    width: 100%;
}

.pagination-card {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0.75rem;
    border-radius: 5rem;
    background-color: var(--background-color);
    padding: 1rem 2rem;
}

.pagination-info {
    flex-grow: 1;
}

.pagination-controls {
    display: flex;
    align-items: center;
}

.pagination-controls button {
    margin: 0 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 0.5rem;
    background-color: var(--primary-color);
    color: #1E1E1E;
    cursor: pointer;
}

.page-numbers {
    display: flex;
}

.page-numbers span {
    margin: 0 0.25rem;
    padding: 0.5rem;
    border: 1px solid var(--primary-color);
    border-radius: 0.5rem;
    cursor: pointer;
}

.page-numbers span.current-page {
    background-color: #5148FA;
    color: white;
}

input {
    width: 100%;
    padding: 8px;
    border: 1px solid #C5C5C5;
    border-radius: 5px;
    background-color: #fff;
    color: #000;
    /* Text color */
}

.adviser-button {
    width: 12rem;
    height: 2.75rem;
    border-radius: 1rem;
}

.adviser-button p {
    font-size: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/molecules/table/table.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB,yCAAyC;IACzC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,yCAAyC;IACzC,SAAS;IACT,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,qBAAqB;IACrB,sCAAsC;IACtC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sCAAsC;IACtC,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".card-background {\n    width: 100%;\n    flex-shrink: 0;\n    border-radius: 1.5rem;\n    background-color: var(--background-color);\n    margin: 0rem 0.75rem;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n}\n\n.custom-table {\n    height: 100vh;\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.custom-table th,\n.custom-table td {\n    height: 4.3125rem;\n    padding: 1rem;\n}\n\n.custom-table th:first-child,\n.custom-table td:first-child {\n    border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.custom-table th:last-child,\n.custom-table td:last-child {\n    border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.custom-table td {\n    position: relative;\n}\n\n.custom-table td:last-child::after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 2px;\n    background-color: var(--background-color);\n    bottom: 0;\n    left: 0;\n    transition: width 0.3s ease;\n}\n\n.custom-table td:last-child:hover::after {\n    width: 100%;\n}\n\n.custom-table .align-left {\n    text-align: left;\n}\n\n.custom-table .align-right {\n    text-align: right;\n}\n\n.custom-table tr:nth-child(even) {\n    background: rgba(217, 217, 217, 0.15);\n}\n\n.custom-table tr.with-link:hover {\n    background-color: rgba(217, 217, 217, 0.3);\n    cursor: pointer;\n}\n\n.custom-table tr.with-link:hover td:last-child::after {\n    width: 100%;\n}\n\n.custom-table .table-header:hover {\n    background-color: transparent;\n    cursor: default;\n}\n\n.custom-table td.with-link:hover::after {\n    width: 100%;\n}\n\n.pagination-card {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    margin: 1rem 0.75rem;\n    border-radius: 5rem;\n    background-color: var(--background-color);\n    padding: 1rem 2rem;\n}\n\n.pagination-info {\n    flex-grow: 1;\n}\n\n.pagination-controls {\n    display: flex;\n    align-items: center;\n}\n\n.pagination-controls button {\n    margin: 0 0.5rem;\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: 0.5rem;\n    background-color: var(--primary-color);\n    color: #1E1E1E;\n    cursor: pointer;\n}\n\n.page-numbers {\n    display: flex;\n}\n\n.page-numbers span {\n    margin: 0 0.25rem;\n    padding: 0.5rem;\n    border: 1px solid var(--primary-color);\n    border-radius: 0.5rem;\n    cursor: pointer;\n}\n\n.page-numbers span.current-page {\n    background-color: #5148FA;\n    color: white;\n}\n\ninput {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #C5C5C5;\n    border-radius: 5px;\n    background-color: #fff;\n    color: #000;\n    /* Text color */\n}\n\n.adviser-button {\n    width: 12rem;\n    height: 2.75rem;\n    border-radius: 1rem;\n}\n\n.adviser-button p {\n    font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
